import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Play } from 'lucide-react';
import ButtonImg from './assets/Button.svg';

const HeroSection = () => {
    const [showVideo, setShowVideo] = useState(false);
    const youtubeVideoId = 'M9fgYtzciy8';

    const handlePlayClick = () => {
        setShowVideo(true);
    };

    const handleCloseVideo = () => {
        setShowVideo(false);
    };

    return (
        <section className="bg-gray-50 px-4 sm:px-6 lg:px-8 py-16 md:py-24">
            <div className="max-w-[1440px] mx-auto text-center">
                {/* Main Heading */}
                <div className="max-w-4xl mx-auto">
                    <h1 className="text-[42px] sm:text-[54px] lg:text-[68px] leading-[1.08] tracking-[-0.02em] font-semibold text-gray-900">
                        The operating system for modern real estate agents
                    </h1>
                    <p className="mt-8 max-w-2xl mx-auto text-base sm:text-lg text-gray-500 leading-relaxed">
                        Capture leads, automate follow-ups, and launch your professional property website instantly &mdash; all from one powerful dashboard.
                    </p>
                </div>

                {/* CTAs */}
                <div className="mt-10 flex flex-wrap justify-center gap-3 sm:gap-4">
                    <Link
                        to="/signup"
                        className="inline-flex items-center justify-center bg-black text-white px-7 py-3 rounded-lg text-sm sm:text-base font-medium hover:bg-gray-800 transition-colors"
                    >
                        Try for Free
                    </Link>
                    <Link
                        to="/login"
                        className="inline-flex items-center justify-center border border-gray-300 bg-gray-100 text-gray-900 px-7 py-3 rounded-lg text-sm sm:text-base font-medium hover:bg-gray-200 transition-colors"
                    >
                        Login
                    </Link>
                </div>

                {/* Demo Section */}
                <div className="mt-14 md:mt-16 max-w-5xl mx-auto rounded-2xl border border-gray-200 bg-gray-100 overflow-hidden shadow-xl">
                    <div className="px-5 md:px-8 py-4 border-b border-gray-200 text-sm md:text-base text-gray-900">
                        See how we create an autonomous AI agent in just <span className="font-semibold underline">5 minutes.</span>
                    </div>

                    <div className="relative bg-gray-100">
                        <img src={ButtonImg} alt="AI agent platform demo preview" className="w-full h-auto" />

                        <button
                            onClick={handlePlayClick}
                            className="absolute inset-0 m-auto w-16 h-16 md:w-20 md:h-20 rounded-full bg-black/45 text-white flex items-center justify-center hover:bg-black/55 transition-colors"
                            aria-label="Play demo video"
                        >
                            <Play className="w-7 h-7 md:w-9 md:h-9 fill-current" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Video Modal */}
            {showVideo && (
                <div className="fixed inset-0 bg-black/75 flex justify-center items-center z-50 p-4">
                    <div className="relative w-full max-w-4xl">
                        <button
                            onClick={handleCloseVideo}
                            className="absolute -top-8 right-0 text-white text-2xl font-bold hover:text-gray-300 z-10"
                        >
                            &times;
                        </button>
                        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                            <iframe
                                src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&si=B8xZtG5fbO51ozhT`}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                                className="absolute top-0 left-0 w-full h-full rounded-lg"
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default HeroSection;
